export default "__VITE_ASSET__BmEdg894__"